export default "__VITE_ASSET__BI1_fyP9__"